export const NotificationBellIconFilled = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06231 7.66752C6.66228 4.94502 9.13659 3 12 3C14.8634 3 17.3377 4.94502 17.9377 7.66752L18.8405 11.764C19.1861 13.3326 19.8336 14.8236 20.7487 16.1583C20.9126 16.3973 21 16.6781 21 16.9654V18.116H3V16.9654C3 16.6781 3.08744 16.3973 3.2513 16.1583C4.16643 14.8236 4.81387 13.3326 5.15955 11.764L6.06231 7.66752Z"
      fill="#F4F4F5"
    />
    <path
      d="M9.54545 19.5055V21H14.4545V19.5055L12 19.5L9.54545 19.5055Z"
      fill="#F4F4F5"
    />
  </svg>
);
